import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation Users($id: Int) {
  deleteUser(id: $id) {
    id
    role
    operatorTeamId
    overseerTeams {
      id,
      name
    }
    name
    email
    fullName
    firstName
    lastName
    middleName
    displayName
    absenceReason
    avgVote
    logged
    ready
    ucceInfo {
      uccePeripheralId
      uccePeripheralFirstName
      uccePeripheralLastName
      uccePeripheralLogin
    }
    useExpress
    ctsUserId
  }
}`;

const fieldsName = {
  activities: 'T_ACTIVITIES',
  online: 'T_ONLINE',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function deleteUser({ id }) {
  return apollo.client.mutate({
    mutation,
    variables: { id: parseInt(id, 10) },
  }).then((res) => res.data.deleteUser)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        if (errors.length) {
          throw errors.map(onParseErrors);
        } else {
          throw err.graphQLErrors[0].message;
        }
      } else {
        throw err;
      }
    });
}

export default deleteUser;
